import * as Tabs from '@wandb/weave/components/Tabs';
import React, {useEffect, useState} from 'react';

import {useDebounceState} from '../../../util/hooks';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawerContextProvider';
import {MultiMetricPanelAdd} from './MultiMetricPanelAdd';
import {usePanelsQuickAddContext} from './PanelsQuickAddContext';
import {QuickAddHeader} from './QuickAddHeader';
import {SingleKeyPanelAdd} from './SingleKeyPanelAdd';

export const PanelsQuickAdd = () => {
  const {targetSectionRef} = useWorkspaceDrawerContext();
  const isMultiMetricQuickAddAllowed = !targetSectionRef; // MMQA is not supported at section-level

  const [selectedTab, setSelectedTab] = useState('single-key');

  // shared search query value
  const {initialSearchStr} = usePanelsQuickAddContext();
  const [searchStr, dSearchStr, setSearchStr] = useDebounceState(
    initialSearchStr,
    300
  );
  useEffect(
    () => setSearchStr(initialSearchStr),
    [initialSearchStr, setSearchStr]
  );

  return (
    <div className="h-full flex flex-col">
      <QuickAddHeader />
      {!isMultiMetricQuickAddAllowed && (
        <SingleKeyPanelAdd
          searchStr={searchStr}
          dSearchStr={dSearchStr}
          setSearchStr={setSearchStr}
        />
      )}
      {isMultiMetricQuickAddAllowed && (
        <Tabs.Root
          value={selectedTab}
          className="h-full flex flex-col"
          onValueChange={value => setSelectedTab(value)}>
          <Tabs.List className="mx-24 mt-16 shrink-0">
            <Tabs.Trigger value="single-key">Single-key panels</Tabs.Trigger>
            <Tabs.Trigger value="multi-metric">
              Multi-metric panels
            </Tabs.Trigger>
          </Tabs.List>
          <div className="grow shrink min-h-0">
            <Tabs.Content value="single-key" className="h-full">
              <SingleKeyPanelAdd
                searchStr={searchStr}
                dSearchStr={dSearchStr}
                setSearchStr={setSearchStr}
              />
            </Tabs.Content>
            <Tabs.Content value="multi-metric" className="h-full">
              <MultiMetricPanelAdd
                regex={searchStr}
                debouncedRegex={dSearchStr}
                setRegex={setSearchStr}
              />
            </Tabs.Content>
          </div>
        </Tabs.Root>
      )}
    </div>
  );
};
